import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "ma-3 d-flex align-center",
  style: {"gap":"0.5rem"}
}
const _hoisted_2 = { class: "text-body-2 font-weight-bold" }
const _hoisted_3 = { class: "text-h6 font-weight-bold" }
const _hoisted_4 = {
  key: 1,
  class: "ma-3 d-flex flex-column",
  style: {"gap":"0.75rem"}
}
const _hoisted_5 = { class: "d-flex align-center justify-space-between" }
const _hoisted_6 = { class: "text-overline text-grey" }
const _hoisted_7 = { class: "text-h6 font-weight-bold" }
const _hoisted_8 = { class: "d-flex align-center justify-space-between" }
const _hoisted_9 = {
  class: "d-flex align-center",
  style: {"gap":"0.3rem"}
}
const _hoisted_10 = { class: "text-body-2 text-primary font-weight-bold" }
const _hoisted_11 = {
  key: 1,
  class: "text-body-2 text-amber-darken-3 font-weight-bold"
}
const _hoisted_12 = {
  key: 3,
  class: "text-body-2 text-grey font-weight-bold"
}
const _hoisted_13 = { class: "text-caption text-grey" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_app_bar_nav_icon = _resolveComponent("v-app-bar-nav-icon")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_app_bar_title = _resolveComponent("v-app-bar-title")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_ai_report_status_chip = _resolveComponent("ai-report-status-chip")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_main = _resolveComponent("v-main")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_app_bar, {
      color: "primary",
      flat: "",
      app: "",
      dark: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_app_bar_nav_icon, {
          style: {"position":"absolute"},
          onClick: _ctx.goBack
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, {
              size: "large",
              color: "white"
            }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createTextVNode("mdi-chevron-left", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_v_spacer),
        _createVNode(_component_v_app_bar_title, { style: {"min-width":"fit-content","font-size":"14px"} }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('aiReport.title')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_v_spacer)
      ]),
      _: 1
    }),
    _createVNode(_component_v_main, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('aiReport.fiscalYear')), 1),
          _createVNode(_component_v_btn, {
            variant: "outlined",
            size: "small",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeYear(-1)))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createTextVNode("mdi-chevron-left", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('aiReport.top.yearLabel', { year: _ctx.year })), 1),
          _createVNode(_component_v_btn, {
            variant: "outlined",
            size: "small",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeYear(1)))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                  _createTextVNode("mdi-chevron-right", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        (_ctx.isFetching)
          ? (_openBlock(), _createBlock(_component_v_progress_linear, {
              key: 0,
              indeterminate: "",
              color: "primary"
            }))
          : _createCommentVNode("", true),
        (_ctx.top)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.top.quarters, (q) => {
                return (_openBlock(), _createBlock(_component_v_card, {
                  key: q.quarter,
                  variant: "outlined",
                  class: _normalizeClass(["pa-4", _ctx.cardClass(q)]),
                  onClick: ($event: any) => (_ctx.toQuarter(q.quarter))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('aiReport.quarterLabel', { quarter: q.quarter })), 1),
                        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.monthsLabelWithNames(q.monthsLabel)), 1)
                      ]),
                      _createVNode(_component_v_icon, { color: "primary" }, {
                        default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                          _createTextVNode("mdi-chevron-right", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _createVNode(_component_v_divider, { class: "my-2" }),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createVNode(_component_ai_report_status_chip, { status: "published" }),
                        _createElementVNode("span", _hoisted_10, _toDisplayString(q.publishedCount), 1),
                        (q.draftCount > 0)
                          ? (_openBlock(), _createBlock(_component_ai_report_status_chip, {
                              key: 0,
                              status: "draft"
                            }))
                          : _createCommentVNode("", true),
                        (q.draftCount > 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(q.draftCount), 1))
                          : _createCommentVNode("", true),
                        (q.notGeneratedCount > 0)
                          ? (_openBlock(), _createBlock(_component_ai_report_status_chip, {
                              key: 2,
                              status: "notGenerated"
                            }))
                          : _createCommentVNode("", true),
                        (q.notGeneratedCount > 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(q.notGeneratedCount), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('aiReport.top.totalChildren', { count: q.totalChildren })), 1)
                    ]),
                    _createVNode(_component_v_progress_linear, {
                      "model-value": _ctx.publishProgress(q),
                      color: "primary",
                      "bg-color": "grey-lighten-3",
                      height: "6",
                      rounded: "",
                      class: "mt-3"
                    }, null, 8, ["model-value"])
                  ]),
                  _: 2
                }, 1032, ["class", "onClick"]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (!_ctx.isFetching && _ctx.top && _ctx.top.quarters.every(_ctx.isQuarterEmpty))
          ? (_openBlock(), _createBlock(_component_v_alert, {
              key: 2,
              type: "info",
              variant: "outlined",
              class: "ma-3"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('aiReport.top.empty')), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}